import React from 'react'
import AD from 'react-google-publisher-tag';
import { get } from 'lodash'

import './style.css'

class RectangleAd extends React.Component {
  render() {
    return <div className={`rectangle-ad-container` + (get(this.props, "layout.settings.isHidden") ? " hide" : "")}>
      <AD path={get(this.props.data, "metadataMap.adTag")} dimensions={[[300, 250]]} />
    </div>;
  }
}

export default RectangleAd